var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-el"},[(_vm.fetched)?_c('line-chart',{attrs:{"chartdata":_vm.messages,"options":_vm.options,"height":100}}):_c('div',{staticClass:"qt-block-ui"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }